const baseTranslations = {
  fr: {
    navHome: 'Accueil',
    navShop: 'Boutique',
    navCollections: 'Collections',
    navAbout: 'A propos',
    navContact: 'Contact',
    navUsers: 'Utilisateurs',
    navOrders: 'Commandes',
    navProducts: 'Produits',
    searchProducts: 'Rechercher des produits',
    openCart: 'Ouvrir le panier',
    openAccountMenu: 'Ouvrir le menu du compte',
    customerFallback: 'Client Solarlight',
    connectedAccount: 'Compte connecte',
    myAccount: 'Mon espace',
    myOrders: 'Mes commandes',
    cart: 'Panier',
    messages: 'Messages',
    logout: 'Se deconnecter',
    login: 'Se connecter',
    showMenu: 'Afficher le menu',
    languageLabel: 'Changer la langue',
    languageShort: 'FR',
    languageNext: 'EN',
    themeLightLabel: 'Passer au mode clair',
    themeDarkLabel: 'Passer au mode sombre',
    footerSecurePaymentTitle: 'Paiement securise',
    footerSecurePaymentText: 'Commande protegee pour chaque achat',
    footerDeliveryTitle: 'Livraison express',
    footerDeliveryText: 'Preparation rapide partout au Maroc',
    footerWarrantyTitle: 'Garantie 2 ans',
    footerWarrantyText: 'Concu pour un usage quotidien interieur et exterieur',
    footerSupportTitle: 'Service client',
    footerSupportText: 'Accompagnement avant et apres votre commande',
    footerBrandText: 'Specialiste de l eclairage professionnel, nous proposons des lampes alliant design, performance et durabilite.',
    socialNetworks: 'Reseaux sociaux',
    newsletterPlaceholder: 'Abonnez-vous a notre newsletter',
    subscribe: 'S abonner',
    navigation: 'Navigation',
    footerNewsletterText: 'Inscrivez-vous a notre newsletter pour recevoir nos offres et nouveautes.',
    viewShop: 'Voir toute la boutique',
    rights: '(c) 2026 Solarlight. Tous droits reserves.',
    paymentText: 'Visa, Mastercard, paiement securise et accompagnement premium.'
  },
  en: {
    navHome: 'Home',
    navShop: 'Shop',
    navCollections: 'Collections',
    navAbout: 'About',
    navContact: 'Contact',
    navUsers: 'Users',
    navOrders: 'Orders',
    navProducts: 'Products',
    searchProducts: 'Search products',
    openCart: 'Open cart',
    openAccountMenu: 'Open account menu',
    customerFallback: 'Solarlight customer',
    connectedAccount: 'Connected account',
    myAccount: 'My account',
    myOrders: 'My orders',
    cart: 'Cart',
    messages: 'Messages',
    logout: 'Log out',
    login: 'Log in',
    showMenu: 'Show menu',
    languageLabel: 'Change language',
    languageShort: 'EN',
    languageNext: 'FR',
    themeLightLabel: 'Switch to light mode',
    themeDarkLabel: 'Switch to dark mode',
    footerSecurePaymentTitle: 'Secure payment',
    footerSecurePaymentText: 'Protected checkout for every order',
    footerDeliveryTitle: 'Express delivery',
    footerDeliveryText: 'Fast preparation throughout Morocco',
    footerWarrantyTitle: '2-year warranty',
    footerWarrantyText: 'Built for everyday indoor and outdoor use',
    footerSupportTitle: 'Customer service',
    footerSupportText: 'Support before and after your order',
    footerBrandText: 'Professional lighting specialist offering lamps that combine design, performance, and durability.',
    socialNetworks: 'Social networks',
    newsletterPlaceholder: 'Subscribe to our newsletter',
    subscribe: 'Subscribe',
    navigation: 'Navigation',
    footerNewsletterText: 'Subscribe to our newsletter to receive offers and new arrivals.',
    viewShop: 'View the full shop',
    rights: '(c) 2026 Solarlight. All rights reserved.',
    paymentText: 'Visa, Mastercard, secure payment, and premium support.'
  }
}

const productCategoryNames = {
  en: {
    Lustres: 'chandelier',
    Suspensions: 'pendant light',
    Appliques: 'wall light',
    Lampadaires: 'floor lamp',
    'Lampes a poser': 'table lamp',
    Spots: 'spotlight'
  },
  fr: {
    chandelier: 'Lustres',
    chandeliers: 'Lustres',
    'pendant light': 'Suspensions',
    'pendant lights': 'Suspensions',
    'wall light': 'Appliques',
    'wall lights': 'Appliques',
    'floor lamp': 'Lampadaires',
    'floor lamps': 'Lampadaires',
    'table lamp': 'Lampes a poser',
    'table lamps': 'Lampes a poser',
    spotlight: 'Spots',
    spotlights: 'Spots'
  }
}

const resolveProductCategoryName = (value, targetLanguage) => {
  const compactValue = String(value || '').trim()
  const lookup = productCategoryNames[targetLanguage] || {}
  return lookup[compactValue] || compactValue
}

const productPhrasePairs = [
  ['Lustres', 'Chandeliers'],
  ['Lustre', 'Chandelier'],
  ['Suspensions', 'Pendant lights'],
  ['Suspension', 'Pendant light'],
  ['Appliques', 'Wall lights'],
  ['Applique', 'Wall light'],
  ['Lampadaires', 'Floor lamps'],
  ['Lampadaire', 'Floor lamp'],
  ['Lampes a poser', 'Table lamps'],
  ['Lampe a poser', 'Table lamp'],
  ['Lampe de chevet', 'Bedside lamp'],
  ['Lampe de bureau', 'Desk lamp'],
  ['Lampe de table', 'Table lamp'],
  ['Lampe', 'Lamp'],
  ['Luminaires', 'Lights'],
  ['Luminaire', 'Light'],
  ['lampes', 'lamps'],
  ['lampe', 'lamp'],
  ['solaires', 'solar'],
  ['solaire', 'solar'],
  ['Solaire', 'Solar'],
  ['Piquet', 'Stake'],
  ['Borne', 'Bollard'],
  ['Projecteur', 'Floodlight'],
  ['Projecteurs', 'Floodlights'],
  ['Detecteur', 'Sensor'],
  ['Mouvement', 'Motion'],
  ['Noir', 'Black'],
  ['Blanc', 'White'],
  ['chaud', 'warm'],
  ['froid', 'cool'],
  ['jardin', 'garden'],
  ['murale', 'wall'],
  ['exterieur', 'outdoor'],
  ['terrasse', 'terrace'],
  ['Spots', 'Spotlights'],
  ['Spot', 'Spotlight'],
  ['cristal', 'crystal'],
  ['moderne', 'modern'],
  ['contemporain', 'contemporary'],
  ['lumieres', 'lights'],
  ['verre fume', 'smoked glass'],
  ['design', 'designer'],
  ['noir et laiton', 'black and brass'],
  ['anneaux LED', 'LED rings'],
  ['minimaliste chambre', 'minimalist bedroom'],
  ['signature cuivre', 'copper signature'],
  ['sphere opaline', 'opal sphere'],
  ['grand salon luxe', 'large luxury living room'],
  ['halo doree', 'gold halo'],
  ['industrielle noire', 'black industrial'],
  ['verre ambre', 'amber glass'],
  ['lineaire salle a manger', 'linear dining room'],
  ['globe blanche', 'white globe'],
  ['trio moderne', 'modern trio'],
  ['laiton minimal', 'minimal brass'],
  ['scandinave bois', 'Scandinavian wood'],
  ['opaline premium', 'premium opal'],
  ['cuisine LED', 'LED kitchen'],
  ['murale LED slim', 'slim LED wall'],
  ['noire orientable', 'adjustable black'],
  ['laiton chambre', 'bedroom brass'],
  ['verre satine', 'satin glass'],
  ['duo salon', 'living room duo'],
  ['lecture pivotante', 'swiveling reading'],
  ['couloir moderne', 'modern hallway'],
  ['hotel premium', 'premium hotel'],
  ['geometrique or', 'gold geometric'],
  ['ambiance douce', 'soft ambience'],
  ['arc luxe', 'luxury arc'],
  ['noir mat', 'matte black'],
  ['tripode bois', 'wood tripod'],
  ['lecture LED', 'LED reading'],
  ['design salon', 'designer living room'],
  ['courbe dore', 'gold curved'],
  ['textile beige', 'beige fabric'],
  ['minimal LED', 'minimal LED'],
  ['chambre cosy', 'cozy bedroom'],
  ['de chevet opaline', 'opal bedside'],
  ['de bureau noire', 'black desk'],
  ['de table laiton', 'brass table'],
  ['vintage atelier', 'vintage workshop'],
  ['boule verre fume', 'smoked glass globe'],
  ['ceramique blanche', 'white ceramic'],
  ['de nuit tactile', 'touch night'],
  ['marbre et or', 'marble and gold'],
  ['ambiance salon', 'living room ambience'],
  ['LED rechargeable', 'rechargeable LED'],
  ['LED blanc chaud', 'warm white LED'],
  ['encastrable noir', 'black recessed'],
  ['orientable plafond', 'adjustable ceiling'],
  ['salle de bain IP65', 'IP65 bathroom'],
  ['rail moderne', 'modern track'],
  ['mini encastre', 'mini recessed'],
  ['duo directionnel', 'directional duo'],
  ['salon premium', 'premium living room'],
  ['basse consommation', 'low energy'],
  ['finition', 'finish'],
  ['usage', 'use'],
  ['categorie', 'category'],
  ['garantie', 'warranty'],
  ['laiton brosse', 'brushed brass'],
  ['verre opalin', 'opal glass'],
  ['chrome satine', 'satin chrome'],
  ['blanc sable', 'sand white'],
  ['salon et salle a manger', 'living room and dining room'],
  ['ilot, table et entree', 'island, table, and entrance'],
  ['couloir, tete de lit et sejour', 'hallway, headboard, and living room'],
  ['coin lecture et salon', 'reading corner and living room'],
  ['chevet, bureau et console', 'bedside, desk, and console'],
  ['plafond et circulation', 'ceiling and passage areas'],
  ['interieur', 'indoor']
]

const phrasePairs = [
  ...productPhrasePairs,
  ['A propos de nos lampes solaires', 'About our solar lamps'],
  ['Une boutique claire, moderne et specialisee dans l eclairage solaire.', 'A clear, modern shop specialized in solar lighting.'],
  ['Chaque produit est concu pour offrir la meilleure qualite, une longue duree de vie et un eclairage efficace.', 'Each product is designed to deliver excellent quality, long life, and efficient lighting.'],
  ['Nous selectionnons avec soin des luminaires solaires performants pour garder une empreinte lumineuse positive, a la fois esthetique et durable.', 'We carefully select high-performance solar lighting to keep a positive light footprint that is both beautiful and durable.'],
  ['Benefices', 'Benefits'],
  ['Pourquoi choisir Solarlight', 'Why choose Solarlight'],
  ['Eco-responsable', 'Eco-friendly'],
  ['Des solutions lumineuses durables qui reduisent votre empreinte et vos couts.', 'Durable lighting solutions that reduce your footprint and your costs.'],
  ['Economie d energie', 'Energy saving'],
  ['Une consommation reduite grace a des panneaux solaires haute performance.', 'Lower consumption thanks to high-performance solar panels.'],
  ['Installation facile', 'Easy installation'],
  ['Des luminaires faciles a installer, sans cablage, pour une utilisation immediate.', 'Easy-to-install lights with no wiring, ready for immediate use.'],
  ['Eclairage exterieur', 'Outdoor lighting'],
  ['Des lampes concues pour resister aux intemperies et garantir la securite.', 'Lamps designed to withstand weather and improve safety.'],
  ['Commandez en toute securite sur notre site.', 'Order securely on our website.'],
  ['Livraison rapide partout au Maroc.', 'Fast delivery throughout Morocco.'],
  ['Sur tous nos luminaires solaires.', 'On all our solar lights.'],
  ['Nous sommes disponibles pour vous accompagner.', 'We are available to support you.'],
  ['Collection Solarlight', 'Solarlight collection'],
  ['Un eclairage premium, lumineux et naturel a vivre.', 'Premium, bright, natural lighting for everyday living.'],
  ['Decouvrir les lampes solaires', 'Discover solar lamps'],
  ['Voir les collections', 'View collections'],
  ['L eclairage solaire qui sublime vos espaces.', 'Solar lighting that elevates your spaces.'],
  ['L eclairage solaire qui', 'Solar lighting that'],
  ['sublime', 'elevates'],
  ['vos espaces.', 'your spaces.'],
  ['Solarlight propose une boutique moderne dediee aux luminaires solaires, alliant design elegant, durabilite et performance pour illuminer chaque instant, tout en respectant la nature.', 'Solarlight offers a modern shop dedicated to solar lighting, combining elegant design, durability, and performance to brighten every moment while respecting nature.'],
  ['Voir la boutique', 'View the shop'],
  ['Explorer les collections', 'Explore collections'],
  ['Produits vedettes', 'Featured products'],
  ['Nos 5 selections du moment', 'Our 5 current picks'],
  ['Une selection pensee avec soin pour vous offrir les meilleurs luminaires solaires.', 'A carefully curated selection to offer you the best solar lights.'],
  ['Impossible de charger les produits mis en avant pour le moment.', 'Unable to load featured products right now.'],
  ['Choisir par ambiance', 'Shop by atmosphere'],
  ['Voir tous les produits', 'View all products'],
  ['Categorie', 'Category'],
  ['produits', 'products'],
  ['Paiement carte avec prise en charge Visa et Mastercard.', 'Card payment with Visa and Mastercard support.'],
  ['Expedition rapide depuis notre selection de luminaires.', 'Fast shipping from our lighting selection.'],
  ['Des produits fiables concus pour durer au quotidien.', 'Reliable products built to last every day.'],
  ['Une vraie assistance avant l achat et apres la livraison.', 'Real support before purchase and after delivery.'],

  ['Filtres boutique', 'Shop filters'],
  ['Recherche', 'Search'],
  ['Nom du produit', 'Product name'],
  ['Toutes les categories', 'All categories'],
  ['Prix minimum', 'Minimum price'],
  ['Prix maximum', 'Maximum price'],
  ['Prix minimum (EUR)', 'Minimum price (EUR)'],
  ['Prix maximum (EUR)', 'Maximum price (EUR)'],
  ['Trier', 'Sort'],
  ['Plus recents', 'Newest'],
  ['Prix croissant', 'Price low to high'],
  ['Prix decroissant', 'Price high to low'],
  ['Nom A a Z', 'Name A to Z'],
  ['Nom Z a A', 'Name Z to A'],
  ['Reinitialiser', 'Reset'],
  ['Accueil', 'Home'],
  ['Nos luminaires solaires', 'Our solar lights'],
  ['Nos luminaires', 'Our solar'],
  ['solaires', 'lights'],
  ['Explorez la collection SolarLight avec un chargement fluide :', 'Explore the SolarLight collection with smooth loading:'],
  ['des pages legeres et rapides pendant votre navigation.', 'light, fast pages while you browse.'],
  ['Boutique', 'Shop'],
  ['Changer l affichage des produits', 'Change product display'],
  ['Afficher en grille', 'Show grid view'],
  ['Afficher en liste', 'Show list view'],
  ['Impossible de charger les produits pour le moment.', 'Unable to load products right now.'],
  ['Chargement indisponible', 'Loading unavailable'],
  ['Chargement des produits supplementaires...', 'Loading more products...'],
  ['Vous avez atteint la fin du catalogue.', 'You have reached the end of the catalog.'],
  ['Aucun produit ne correspond a votre recherche', 'No product matches your search'],
  ['Essayez un autre mot-cle ou reinitialisez les filtres.', 'Try another keyword or reset the filters.'],
  ['Collection', 'Collection'],
  ['Collection signature', 'Signature collection'],

  ['Veuillez vous connecter pour ajouter un produit au panier', 'Please log in to add a product to the cart'],
  ['Veuillez vous connecter pour ajouter ce produit au panier', 'Please log in to add this product to the cart'],
  ['Veuillez vous connecter pour ajouter ce produit aux favoris', 'Please log in to add this product to favorites'],
  ['Produit ajoute au panier', 'Product added to cart'],
  ['Produit ajoute aux favoris', 'Product added to favorites'],
  ['Impossible d ajouter ce produit', 'Unable to add this product'],
  ['Ajouter au panier', 'Add to cart'],
  ['Ajout...', 'Adding...'],
  ['Luminaire premium', 'Premium light'],
  ['Sans categorie', 'No category'],
  ['Sans nom', 'Unnamed'],
  ['En stock', 'In stock'],
  ['Faible stock', 'Low stock'],
  ['Rupture de stock', 'Out of stock'],
  ['Produit introuvable', 'Product not found'],
  ['Impossible de charger les avis', 'Unable to load reviews'],
  ['Veuillez vous connecter pour laisser un avis', 'Please log in to leave a review'],
  ['Avis ajoute avec succes', 'Review added successfully'],
  ['Impossible d ajouter votre avis', 'Unable to add your review'],
  ['Agrandir l image', 'Enlarge image'],
  ['Image precedente', 'Previous image'],
  ['Image suivante', 'Next image'],
  ['Lampadaires solaires', 'Solar lamp posts'],
  ['Quantite', 'Quantity'],
  ['Livraison rapide', 'Fast delivery'],
  ['Livraison partout au Maroc sous 24h a 48h', 'Delivery throughout Morocco within 24h to 48h'],
  ['Paiement a la livraison ou en ligne', 'Cash on delivery or online payment'],
  ['Sur tous nos lampadaires solaires', 'On all our solar lamp posts'],
  ['Retour facile', 'Easy returns'],
  ['Retour sous 7 jours si vous n etes pas satisfait', 'Return within 7 days if you are not satisfied'],
  ['Une solution d eclairage solaire performante et durable', 'A powerful and durable solar lighting solution'],
  ['Decouvrez ce luminaire solaire soigneusement selectionne.', 'Discover this carefully selected solar light.'],
  ['Son design moderne et robuste s integre parfaitement a tous vos amenagements exterieurs.', 'Its modern, robust design blends perfectly into all your outdoor spaces.'],
  ['avis clients', 'customer reviews'],
  ['Chargement des avis...', 'Loading reviews...'],
  ['Aucun avis pour ce produit pour le moment.', 'No reviews for this product yet.'],
  ['Laisser un avis sur ce produit', 'Leave a review for this product'],
  ['Note', 'Rating'],
  ['Commentaire', 'Comment'],
  ['Votre avis sur ce produit', 'Your review of this product'],
  ['Verification', 'Verification'],
  ['Nous verifions si ce produit existe dans vos commandes.', 'We are checking whether this product exists in your orders.'],
  ['Avis deja envoye', 'Review already sent'],
  ['Votre avis pour ce produit est deja affiche dans la section avis.', 'Your review for this product is already shown in the reviews section.'],
  ['Avis reserve aux acheteurs', 'Reviews reserved for buyers'],
  ['Vous pouvez laisser un avis apres avoir achete ce produit.', 'You can leave a review after buying this product.'],
  ['Avis clients', 'Customer reviews'],
  ['Connectez-vous et commandez ce produit pour partager votre avis.', 'Log in and order this product to share your review.'],
  ['Voir details', 'View details'],
  ['Caracteristiques', 'Specifications'],
  ['Ajouter a la liste de souhaits', 'Add to wishlist'],
  ['Un luminaire au design soigne pour transformer vos espaces avec elegance.', 'A carefully designed light to transform your spaces with elegance.'],
  ['Envoyer mon avis', 'Send my review'],
  ['Envoi en cours...', 'Sending...'],
  ['Utilisateur', 'User'],
  ['vue', 'view'],
  ['5 etoiles', '5 stars'],
  ['4 etoiles', '4 stars'],
  ['3 etoiles', '3 stars'],
  ['2 etoiles', '2 stars'],
  ['1 etoile', '1 star'],

  ['Panier vide', 'Empty cart'],
  ['Votre panier est vide.', 'Your cart is empty.'],
  ['Continuer mes achats', 'Continue shopping'],
  ['Resume de commande', 'Order summary'],
  ['Sous-total', 'Subtotal'],
  ['Livraison', 'Delivery'],
  ['Gratuite', 'Free'],
  ['Total', 'Total'],
  ['Passer au paiement', 'Proceed to checkout'],
  ['Retirer', 'Remove'],
  ['Supprime du panier', 'Removed from cart'],
  ['Impossible de supprimer ce produit', 'Unable to remove this product'],
  ['Panier mis a jour', 'Cart updated'],
  ['Impossible de mettre a jour le panier', 'Unable to update cart'],
  ['Diminuer la quantite', 'Decrease quantity'],
  ['Augmenter la quantite', 'Increase quantity'],

  ['Information de contact', 'Contact information'],
  ['Adresse e-mail', 'Email address'],
  ['Telephone', 'Phone'],
  ['Adresse', 'Address'],
  ['Ville', 'City'],
  ['Code postal', 'Postal code'],
  ['Pays', 'Country'],
  ['Maroc', 'Morocco'],
  ['France', 'France'],
  ['Espagne', 'Spain'],
  ['Mode de paiement', 'Payment method'],
  ['Paiement a la livraison', 'Cash on delivery'],
  ['Carte bancaire', 'Bank card'],
  ['Visa / Mastercard', 'Visa / Mastercard'],
  ['Carte de test', 'Test card'],
  ['Chargement des options de paiement...', 'Loading payment options...'],
  ['Nom sur la carte', 'Name on card'],
  ['Numero de carte', 'Card number'],
  ['Mois', 'Month'],
  ['Annee', 'Year'],
  ['Confirmer la commande', 'Confirm order'],
  ['Commande en cours...', 'Ordering...'],
  ['Paiement confirme', 'Payment confirmed'],
  ['Votre paiement a ete accepte.', 'Your payment has been accepted.'],
  ['Merci pour votre commande !', 'Thank you for your order!'],
  ['Votre paiement a ete confirme avec succes. Nous vous enverrons bientot un e-mail avec les details de votre commande.', 'Your payment was confirmed successfully. We will soon send you an email with your order details.'],
  ['Votre commande est enregistree et le montant a ete envoye vers votre compte marchand.', 'Your order is saved and the amount was sent to your merchant account.'],
  ['Paiement echoue', 'Payment failed'],
  ['Le paiement n a pas pu etre finalise.', 'The payment could not be completed.'],
  ['Aucun ordre paye n a ete cree. Vous pouvez reessayer quand vous le souhaitez.', 'No paid order was created. You can try again whenever you want.'],
  ['Paiement en attente', 'Payment pending'],
  ['Votre paiement est en cours de verification.', 'Your payment is being verified.'],
  ['Nous attendons encore la confirmation finale de la passerelle de paiement.', 'We are still waiting for final confirmation from the payment gateway.'],
  ['Retour a la boutique', 'Back to shop'],
  ['Voir mes commandes', 'View my orders'],

  ['Connexion', 'Login'],
  ['Heureux de vous revoir.', 'Happy to see you again.'],
  ['Accedez a votre espace client Solarlight.', 'Access your Solarlight customer area.'],
  ['Mot de passe', 'Password'],
  ['Votre mot de passe', 'Your password'],
  ['Mot de passe oublie ?', 'Forgot password?'],
  ['Entrer dans mon espace', 'Enter my account'],
  ['Vous n avez pas encore de compte ?', 'Do not have an account yet?'],
  ['Creer un compte', 'Create an account'],
  ['Connexion reussie', 'Login successful'],
  ['Inscription', 'Registration'],
  ['Creez votre univers lumineux.', 'Create your bright universe.'],
  ['Ouvrir un compte', 'Open an account'],
  ['Quelques informations suffisent pour commencer.', 'A few details are enough to get started.'],
  ['Nom', 'Last name'],
  ['Prenom', 'First name'],
  ['Confirmation du mot de passe', 'Password confirmation'],
  ['Creer mon compte', 'Create my account'],
  ['Vous avez deja un compte ?', 'Already have an account?'],
  ['Inscription reussie', 'Registration successful'],
  ['Reinitialisation', 'Reset'],
  ['Recuperez votre acces.', 'Recover your access.'],
  ['Entrez votre adresse e-mail pour recevoir un code de verification valable 10 minutes.', 'Enter your email address to receive a verification code valid for 10 minutes.'],
  ['Mot de passe oublie', 'Forgot password'],
  ['Nous vous enverrons un code de reinitialisation par e-mail.', 'We will send you a reset code by email.'],
  ['Envoyer le code', 'Send code'],
  ['Vous vous souvenez de votre mot de passe ?', 'Remember your password?'],
  ['Retour a la connexion', 'Back to login'],
  ['Verifier le code', 'Verify code'],
  ['Confirmez votre code.', 'Confirm your code.'],
  ['Saisissez le code a 6 chiffres recu par e-mail pour continuer la reinitialisation.', 'Enter the 6-digit code received by email to continue the reset.'],
  ['Le code expire 10 minutes apres son envoi.', 'The code expires 10 minutes after it is sent.'],
  ['Code de verification', 'Verification code'],
  ['Vous n avez pas recu le code ?', 'Did not receive the code?'],
  ['Renvoyer un code', 'Send another code'],
  ['Code verifie avec succes', 'Code verified successfully'],
  ['Nouveau mot de passe', 'New password'],
  ['Choisissez un nouveau mot de passe.', 'Choose a new password.'],
  ['Créez un mot de passe securise d au moins 8 caracteres pour proteger votre compte SolarLight.', 'Create a secure password of at least 8 characters to protect your SolarLight account.'],
  ['Reinitialiser le mot de passe', 'Reset password'],
  ['Entrez le code recu puis confirmez votre nouveau mot de passe.', 'Enter the received code then confirm your new password.'],
  ['Confirmez le mot de passe', 'Confirm password'],
  ['Mettre a jour le mot de passe', 'Update password'],
  ['Mot de passe reinitialise avec succes.', 'Password reset successfully.'],

  ['Contactez-nous', 'Contact us'],
  ['Nom complet', 'Full name'],
  ['Votre nom', 'Your name'],
  ['Votre email', 'Your email'],
  ['Sujet', 'Subject'],
  ['Message', 'Message'],
  ['Votre message...', 'Your message...'],
  ['Envoyer le message', 'Send message'],
  ['Message envoye', 'Message sent'],
  ['Impossible d envoyer le message', 'Unable to send message'],
  ['Avis produits', 'Product reviews'],
  ['Ce que nos clients pensent des produits', 'What our customers think about the products'],
  ['Aucun avis produit pour le moment. Le prochain avis envoye apparaitra ici.', 'No product reviews yet. The next submitted review will appear here.'],
  ['Laisser un avis', 'Leave a review'],
  ['Produit achete', 'Purchased product'],
  ['Votre avis sur le produit', 'Your product review'],
  ['Partagez votre avis sur le produit...', 'Share your opinion about the product...'],
  ['Publier mon avis', 'Publish my review'],
  ['Connectez-vous pour publier un avis sur un produit achete.', 'Log in to publish a review for a purchased product.'],
  ['Aucun produit achete disponible pour laisser un avis.', 'No purchased product available for review.'],
  ['Vous avez deja laisse un avis pour tous vos produits achetes.', 'You have already reviewed all your purchased products.'],
  ['Veuillez vous connecter pour laisser un avis produit', 'Please log in to leave a product review'],
  ['Choisissez un produit achete', 'Choose a purchased product'],
  ['Impossible d envoyer l avis', 'Unable to send the review'],
  ['Parlons de votre projet d', 'Let us talk about your'],
  ['eclairage solaire', 'solar lighting project'],
  ['Contactez-nous pour une question ou consultez les avis produits partages par nos clients.', 'Contact us with a question or read product reviews shared by our customers.'],

  ['Solarlight, une vision plus responsable de l eclairage.', 'Solarlight, a more responsible vision of lighting.'],
  ['Solarlight, une vision plus responsable de', 'Solarlight, a more responsible vision of'],
  ['l eclairage.', 'lighting.'],
  ['Nous construisons une boutique e-commerce dediee aux lampes solaires pour offrir une experience plus moderne, plus pratique et plus inspiree autour de l eclairage.', 'We are building an e-commerce shop dedicated to solar lamps to offer a more modern, practical, and inspired lighting experience.'],
  ['Notre objectif', 'Our goal'],
  ['Proposer une boutique specialisee dans les lampes solaires avec une navigation simple, un choix clair et une presentation soignee.', 'Offer a shop specialized in solar lamps with simple navigation, clear choices, and polished presentation.'],
  ['Un e-commerce moderne', 'A modern e-commerce experience'],
  ['Un catalogue plus fluide, des collections lisibles, des fiches detaillees et une experience plus propre du produit au panier.', 'A smoother catalog, clearer collections, detailed product pages, and a cleaner journey from product to cart.'],
  ['Les avantages du solaire', 'The advantages of solar'],
  ['Moins de consommation, plus d autonomie et un eclairage adapte aux exterieurs du quotidien comme aux petits projets d amenagement.', 'Less consumption, more autonomy, and lighting suited for everyday outdoor spaces and smaller design projects.'],
  ['Pourquoi nous choisir', 'Why choose us'],
  ['Pour la coherence du style, la selection des references, le confort d achat et un accompagnement pense pour inspirer confiance.', 'For consistent style, selected references, shopping comfort, and support designed to build trust.'],
  ['Les luminaires solaires et les lampes modernes doivent sembler haut de gamme, pas generiques. Cette refonte apporte cette sensation au parcours d achat.', 'Solar lighting and modern lamps should feel premium, not generic. This redesign brings that feeling to the shopping journey.'],

  ['Tableau de bord client', 'Customer dashboard'],
  ['Espace client', 'Customer area'],
  ['Votre compte', 'Your account'],
  ['Retrouvez votre profil, vos messages et les informations utiles de votre compte.', 'Find your profile, messages, and useful account information.'],
  ['Profil', 'Profile'],
  ['Mon profil', 'My profile'],
  ['Mon espace', 'My space'],
  ['Mes favoris', 'My favorites'],
  ['Mes adresses', 'My addresses'],
  ['Informations du compte', 'Account information'],
  ['Nom complet', 'Full name'],
  ['Compte client', 'Customer account'],
  ['SOLARLIGHT CLIENT', 'SOLARLIGHT CUSTOMER'],
  ['Inscription', 'Registration'],
  ['Date d inscription', 'Registration date'],
  ['Date du compte', 'Account date'],
  ['Telephone', 'Phone'],
  ['Information de contact', 'Contact information'],
  ['Statut du compte', 'Account status'],
  ['Compte actif et pret pour vos prochaines commandes.', 'Account active and ready for your next orders.'],
  ['Conseil deco', 'Decor tip'],
  ['Associez une lampe de table chaude avec une suspension graphique pour equilibrer la piece.', 'Pair a warm table lamp with a graphic pendant light to balance the room.'],
  ['Suivi de vos commandes', 'Order tracking'],
  ['Les produits payes ou confirmes depuis votre panier apparaissent ici.', 'Products paid for or confirmed from your cart appear here.'],
  ['Voir la page detaillee', 'View detailed page'],
  ['Vos produits favoris', 'Your favorite products'],
  ['La liste de favoris sera affichee ici quand des produits seront sauvegardes.', 'Your favorites list will appear here when products are saved.'],
  ['Explorer la boutique', 'Explore the shop'],
  ['Chargement des favoris...', 'Loading favorites...'],
  ['Voir le produit', 'View product'],
  ['Produit retire des favoris', 'Product removed from favorites'],
  ['Adresses', 'Addresses'],
  ['Informations de livraison', 'Delivery information'],
  ['Adresse principale', 'Main address'],
  ['Les adresses de livraison apparaissent avec vos commandes.', 'Delivery addresses appear with your orders.'],
  ['Prochaine etape', 'Next step'],
  ['Ajoutez une adresse lors de votre prochaine commande.', 'Add an address during your next order.'],
  ['Messages envoyes', 'Sent messages'],
  ['Mes messages envoyes', 'My sent messages'],
  ['Les messages envoyes depuis Contactez-nous avec votre email sont affiches ici.', 'Messages sent from Contact us with your email are displayed here.'],
  ['Chargement des messages...', 'Loading messages...'],
  ['Aucun message envoye pour le moment.', 'No sent messages yet.'],
  ['Actualisation...', 'Refreshing...'],
  ['Adresse de livraison non renseignee', 'Shipping address not provided'],
  ['Chargement des commandes...', 'Loading orders...'],
  ['Aucune commande pour le moment.', 'No orders yet.'],
  ['Aucun favori enregistre pour le moment.', 'No favorites saved yet.'],
  ['Espace admin', 'Admin area'],
  ['Gestion SolarLight', 'SolarLight management'],
  ['Gerez les produits, les comptes, les messages et les controles essentiels.', 'Manage products, accounts, messages, and essential controls.'],
  ['Masquer le formulaire', 'Hide form'],
  ['Apercu des produits', 'Product overview'],
  ['Statistiques de vente', 'Sales statistics'],
  ['Apercu des utilisateurs', 'User overview'],
  ['Messages et avis utilisateurs', 'User messages and reviews'],
  ['Administration', 'Administration'],
  ['Total produits', 'Total products'],
  ['Produits au total', 'Total products'],
  ['Valeur totale', 'Total value'],
  ['Acces administrateur', 'Administrator access'],
  ['Securite admin', 'Admin security'],
  ['Les droits admin sont maintenant geres par un role utilisateur et verifies cote backend.', 'Admin rights are now managed by a user role and verified on the backend.'],
  ['Gestion utilisateurs', 'User management'],
  ['Depuis la navigation admin, vous pouvez creer des comptes, modifier leurs infos et changer leur role.', 'From the admin navigation, you can create accounts, edit their info, and change their role.'],
  ['Demandes recues', 'Received requests'],
  ['Depuis le formulaire contact', 'From the contact form'],
  ['Temoignages recus', 'Received testimonials'],
  ['Avis visibles', 'Visible reviews'],
  ['Comptes utilisateurs', 'User accounts'],
  ['Comptes clients', 'Customer accounts'],
  ['Produits a reapprovisionner', 'Products to restock'],
  ['Valeur du stock', 'Stock value'],
  ['Unites disponibles', 'Units available'],
  ['Statistiques', 'Analytics'],
  ['Analytics Dashboard', 'Analytics Dashboard'],
  ['Track sales, orders, customers and revenue in real time.', 'Track sales, orders, customers and revenue in real time.'],
  ['Periode des statistiques', 'Statistics period'],
  ['Today', 'Today'],
  ['This Week', 'This Week'],
  ['This Month', 'This Month'],
  ['This Year', 'This Year'],
  ['Commandes analysees', 'Analyzed orders'],
  ['Sur les 12 derniers mois', 'Over the last 12 months'],
  ['Unites vendues', 'Units sold'],
  ['Quantite totale vendue', 'Total quantity sold'],
  ['Meilleur produit', 'Best product'],
  ['Produit le plus vendu', 'Best-selling product'],
  ['Produits commandes', 'Ordered products'],
  ['Produits avec commandes', 'Products with orders'],
  ['Impossible de charger les statistiques de vente', 'Unable to load sales statistics'],
  ['Suivez les produits les plus vendus, les commandes par mois et le nombre de commandes par produit.', 'Track best-selling products, monthly orders, and order counts by product.'],
  ['Classement par quantite vendue', 'Ranking by sold quantity'],
  ['unites vendues', 'units sold'],
  ['Commandes par mois', 'Orders by month'],
  ['Nombre de commandes creees par mois', 'Number of orders created per month'],
  ['Diagramme des ventes par produit', 'Sales chart by product'],
  ['Chaque produit avec ses unites vendues.', 'Each product with its units sold.'],
  ['Choisissez un produit pour afficher ses unites vendues.', 'Choose a product to show its units sold.'],
  ['Commandes par produit', 'Orders by product'],
  ['Nombre de commandes et quantites vendues pour chaque produit.', 'Order counts and sold quantities for each product.'],
  ['commandes', 'orders'],
  ['Rafraichir', 'Refresh'],

  ['Gestion des Produits', 'Product Management'],
  ['Gerez et suivez vos produits. Modifiez les prix, le stock, les categories et le statut.', 'Manage and track your products. Edit prices, stock, categories, and status.'],
  ['Ajouter un produit', 'Add product'],
  ['Ajouter le produit', 'Add product'],
  ['Modifier le produit', 'Edit product'],
  ['Voir la boutique', 'View the shop'],
  ['Apercu du produit', 'Product preview'],
  ['Modification en cours...', 'Updating...'],
  ['Ajout en cours...', 'Adding...'],
  ['Creation en cours...', 'Creating...'],
  ['Enregistrer les changements', 'Save changes'],
  ['Renseignez les informations du produit. L image peut etre changee a tout moment.', 'Enter product information. The image can be changed at any time.'],
  ['Ajoutez un produit ici. Il sera visible dans la liste admin et dans la boutique utilisateur.', 'Add a product here. It will be visible in the admin list and the customer shop.'],
  ['Mettez a jour le produit selectionne puis enregistrez les changements.', 'Update the selected product, then save changes.'],
  ['Description', 'Description'],
  ['Image', 'Image'],
  ['Stock', 'Stock'],
  ['Prix', 'Price'],
  ['Prix (EUR)', 'Price (EUR)'],
  ['Actions', 'Actions'],
  ['Statut', 'Status'],
  ['Modifier', 'Edit'],
  ['Supprimer', 'Delete'],
  ['Enregistrer', 'Save'],
  ['Enregistrement...', 'Saving...'],
  ['Creer', 'Create'],
  ['Fermer', 'Close'],
  ['Fermer le formulaire', 'Close form'],
  ['Annuler', 'Cancel'],
  ['Produit modifie avec succes', 'Product updated successfully'],
  ['Produit ajoute avec succes', 'Product added successfully'],
  ['Produit cree avec succes', 'Product created successfully'],
  ['Produit supprime avec succes', 'Product deleted successfully'],
  ['Liste des produits admin', 'Admin product list'],
  ['Retrouvez et gerez tous vos produits en un seul endroit.', 'Find and manage all your products in one place.'],
  ['en stock', 'in stock'],
  ['Suppression...', 'Deleting...'],
  ['Impossible de charger les produits admin', 'Unable to load admin products'],
  ['Impossible d enregistrer le produit', 'Unable to save product'],
  ['Impossible de supprimer le produit', 'Unable to delete product'],
  ['Aucun produit trouve.', 'No product found.'],
  ['Aucune donnee disponible.', 'No data available.'],
  ['Approuves', 'Approved'],
  ['A verifier', 'To review'],

  ['Ajouter un utilisateur', 'Add user'],
  ['Ajouter l utilisateur', 'Add user'],
  ['Modifier un utilisateur', 'Edit user'],
  ['Administrateur', 'Administrator'],
  ['Vous pouvez creer un compte, modifier ses informations ou lui donner le role administrateur.', 'You can create an account, edit its information, or give it the administrator role.'],
  ['Liste des utilisateurs', 'User list'],
  ['Ajoutez, modifiez, supprimez des utilisateurs et attribuez le role administrateur.', 'Add, edit, delete users, and assign the administrator role.'],
  ['Sans telephone', 'No phone'],
  ['Renseignez les informations du compte et choisissez le role admin ou user.', 'Enter account information and choose the admin or user role.'],
  ['Role', 'Role'],
  ['Utilisateur', 'User'],
  ['Admins', 'Admins'],
  ['Clients', 'Customers'],
  ['Actif', 'Active'],
  ['Supprimer l utilisateur', 'Delete user'],
  ['Utilisateur modifie avec succes', 'User updated successfully'],
  ['Utilisateur ajoute avec succes', 'User added successfully'],
  ['Utilisateur supprime avec succes', 'User deleted successfully'],
  ['Impossible d enregistrer l utilisateur', 'Unable to save user'],
  ['Impossible de supprimer l utilisateur', 'Unable to delete user'],
  ['Impossible de charger les utilisateurs', 'Unable to load users'],
  ['Aucun utilisateur trouve.', 'No user found.'],
  ['Confirmation mot de passe', 'Password confirmation'],
  ['Messages / Avis', 'Messages / Reviews'],
  ['Messages envoyes depuis Contactez-nous', 'Messages sent from Contact us'],
  ['Avis envoyes par les utilisateurs', 'Reviews sent by users'],
  ['Chaque message envoye depuis le formulaire Contactez-nous apparait ici.', 'Each message sent from the Contact us form appears here.'],
  ['Chaque temoignage envoye depuis Laisser un temoignage apparait ici.', 'Each testimonial sent from Leave a testimonial appears here.'],
  ['Changer entre messages et avis', 'Switch between messages and reviews'],
  ['Messages utilisateurs', 'User messages'],
  ['Avis utilisateurs', 'User reviews'],
  ['Aucun message pour le moment.', 'No messages yet.'],
  ['Chargement des avis...', 'Loading reviews...'],
  ['Aucun avis pour le moment.', 'No reviews yet.'],
  ['Email non renseigne', 'Email not provided'],
  ['Approuve', 'Approved'],
  ['Commandes', 'Orders'],
  ['Suivez les commandes, leurs montants et leur statut de paiement.', 'Track orders, amounts, and payment status.'],
  ['Mes commandes', 'My orders'],
  ['Retrouvez vos commandes payees, leurs statuts et leurs adresses de livraison.', 'Find your paid orders, statuses, and delivery addresses.'],
  ['Commande', 'Order'],
  ['Montant', 'Amount'],
  ['Paiement', 'Payment'],
  ['Date', 'Date'],
  ['Aucune commande trouvee.', 'No order found.'],
  ['Impossible de charger vos commandes', 'Unable to load your orders'],
  ['Paiements', 'Payments'],
  ['Consultez les transactions, la passerelle, le statut et les metadonnees carte non sensibles.', 'View transactions, gateway, status, and non-sensitive card metadata.'],
  ['Aucun paiement trouve.', 'No payment found.'],
  ['Impossible de charger les paiements', 'Unable to load payments'],
  ['En attente', 'Pending'],
  ['Manquant', 'Missing'],
  ['Ajoute', 'Added'],

  ['Applique solaire murale', 'Wall solar light'],
  ['Appliques murales solaires', 'Solar wall lights'],
  ['Borne solaire de terrasse', 'Solar terrace bollard'],
  ['Lampes solaires jardin', 'Garden solar lamps'],
  ['Projecteur solaire exterieur', 'Outdoor solar floodlight'],
  ['Projecteurs solaires', 'Solar floodlights'],
  ['Piquet solaire Iota 8W', 'Iota 8W solar stake light'],
  ['Guirlandes solaires', 'Solar string lights'],
  ['Kits solaires', 'Solar kits'],
  ['Materiau', 'Material'],
  ['Puissance', 'Power'],
  ['Batterie', 'Battery'],
  ['Flux lumineux', 'Luminous flux'],
  ['Autonomie', 'Autonomy'],
  ['Temps de charge', 'Charging time'],
  ['Etancheite', 'Waterproof rating'],
  ['Hauteur recommandee', 'Recommended height'],
  ['Aluminium + ABS', 'Aluminum + ABS'],
  ['Concu pour un usage quotidien exterieur', 'Built for everyday outdoor use'],
  ['Un eclairage mural simple a poser pour l entree, les couloirs et les murs exterieurs.', 'A simple wall light for entrances, corridors, and exterior walls.'],
  ['Des lampes exterieures pensees pour les allees, terrasses et coins detente.', 'Outdoor lamps designed for paths, terraces, and relaxation corners.'],
  ['Des solutions lumineuses plus directes pour facades, acces et zones exterieures.', 'More direct lighting solutions for facades, access points, and outdoor areas.'],
  ['Des ambiances plus douces pour jardins, pergolas et repas en plein air.', 'Softer atmospheres for gardens, pergolas, and outdoor dining.'],
  ['Des ensembles complets pour equiper vos espaces avec une signature lumineuse coherente.', 'Complete sets to equip your spaces with a coherent lighting signature.'],
  ['Installation simple, finition elegante et detecteur reactif. Parfait pour l entree de la maison.', 'Simple installation, elegant finish, and responsive sensor. Perfect for the house entrance.'],
  ['Tres bonne lumiere pour le jardin. Le produit tient bien la charge et donne un rendu propre le soir.', 'Very good light for the garden. The product holds charge well and looks clean at night.'],
  ['Belle ambiance autour de la terrasse. La lumiere est douce et le design reste discret en journee.', 'Beautiful atmosphere around the terrace. The light is soft and the design stays discreet during the day.'],
  ['Eclairage puissant et conforme aux photos. J aurais aime un cable un peu plus long, mais le produit est solide.', 'Powerful lighting and true to the photos. I would have liked a slightly longer cable, but the product is solid.'],

  ['Heureux de vous revoir.', 'Happy to see you again.'],
  ['Heureux de vous', 'Happy to see you'],
  ['revoir.', 'again.'],
  ['Connectez-vous pour retrouver votre panier, vos informations et vos selections de luminaires preferees.', 'Log in to recover your cart, information, and favorite lighting selections.'],
  ['Se connecter', 'Log in'],
  ['Accedez a votre espace client Solarlight.', 'Access your SolarLight customer area.'],
  ['exemple@solarlight.ma', 'example@solarlight.ma'],
  ['Votre mot de passe', 'Your password'],
  ['Mot de passe oublie ?', 'Forgot password?'],
  ['Connexion en cours...', 'Logging in...'],
  ['Entrer dans mon espace', 'Enter my account'],
  ['Vous n avez pas encore de compte ?', 'Do not have an account yet?'],
  ['Creer un compte', 'Create an account'],
  ['Veuillez saisir une adresse e-mail valide.', 'Please enter a valid email address.'],
  ['Le mot de passe doit contenir au moins 8 caracteres.', 'The password must contain at least 8 characters.'],
  ['Connexion reussie', 'Login successful'],
  ['Erreur de connexion', 'Login error'],
  ['Creez votre univers lumineux.', 'Create your lighting universe.'],
  ['Rejoignez Solarlight pour sauvegarder vos favoris, suivre vos achats et transformer votre interieur avec une boutique plus inspiree.', 'Join SolarLight to save favorites, track purchases, and transform your interior with a more inspiring shop.'],
  ['Ouvrir un compte', 'Open an account'],
  ['Quelques informations suffisent pour commencer.', 'A few details are enough to get started.'],
  ['Prenom', 'First name'],
  ['Confirmation du mot de passe', 'Password confirmation'],
  ['Creation en cours...', 'Creating...'],
  ['Creer mon compte', 'Create my account'],
  ['Vous avez deja un compte ?', 'Already have an account?'],
  ['Inscription reussie', 'Registration successful'],
  ['Erreur lors de l inscription', 'Registration error'],
  ['Reinitialisation', 'Reset'],
  ['Recuperez votre acces.', 'Recover your access.'],
  ['Entrez votre adresse e-mail pour recevoir un code de verification valable 10 minutes.', 'Enter your email address to receive a verification code valid for 10 minutes.'],
  ['Mot de passe oublie', 'Forgot password'],
  ['Nous vous enverrons un code de reinitialisation par e-mail.', 'We will send you a reset code by email.'],
  ['Si cet email existe, un code de reinitialisation a ete envoye.', 'If this email exists, a reset code has been sent.'],
  ['Impossible d envoyer le code.', 'Unable to send the code.'],
  ['Envoyer le code', 'Send code'],
  ['Vous vous souvenez de votre mot de passe ?', 'Do you remember your password?'],
  ['Retour a la connexion', 'Back to login'],
  ['Confirmez votre code.', 'Confirm your code.'],
  ['Saisissez le code a 6 chiffres recu par e-mail pour continuer la reinitialisation.', 'Enter the 6-digit code received by email to continue the reset.'],
  ['Verifier le code', 'Verify code'],
  ['Le code expire 10 minutes apres son envoi.', 'The code expires 10 minutes after it is sent.'],
  ['Code de verification', 'Verification code'],
  ['Verification...', 'Verifying...'],
  ['Code verifie avec succes', 'Code verified successfully'],
  ['Code invalide.', 'Invalid code.'],
  ['Vous n avez pas recu le code ?', 'Did not receive the code?'],
  ['Renvoyer un code', 'Resend code'],
  ['Nouveau mot de passe', 'New password'],
  ['Choisissez un nouveau mot de passe.', 'Choose a new password.'],
  ['CrÃ©ez un mot de passe securise d au moins 8 caracteres pour proteger votre compte SolarLight.', 'Create a secure password of at least 8 characters to protect your SolarLight account.'],
  ['Creez un mot de passe securise d au moins 8 caracteres pour proteger votre compte SolarLight.', 'Create a secure password of at least 8 characters to protect your SolarLight account.'],
  ['Reinitialiser le mot de passe', 'Reset password'],
  ['Entrez le code recu puis confirmez votre nouveau mot de passe.', 'Enter the received code, then confirm your new password.'],
  ['Confirmez le mot de passe', 'Confirm password'],
  ['Reinitialisation...', 'Resetting...'],
  ['Mettre a jour le mot de passe', 'Update password'],
  ['Mot de passe reinitialise avec succes.', 'Password reset successfully.'],
  ['Impossible de reinitialiser le mot de passe.', 'Unable to reset password.'],
  ['Retour a la', 'Back to'],
  ['connexion', 'login'],

  ['Votre selection lumineuse', 'Your lighting selection'],
  ['article(s) dans votre panier', 'item(s) in your cart'],
  ['Votre panier est vide', 'Your cart is empty'],
  ['Ajoutez quelques luminaires pour construire votre ambiance ideale.', 'Add a few lights to build your ideal atmosphere.'],
  ['Decouvrir la boutique', 'Discover the shop'],
  ['Panier', 'Cart'],
  ['Protection', 'Protection'],
  ['Incluse', 'Included'],
  ['Entrez votre adresse', 'Enter your address'],
  ['Mode test local, compatible Visa / Mastercard', 'Local test mode, compatible with Visa / Mastercard'],
  ['La commande sera creee sans paiement en ligne', 'The order will be created without online payment'],
  ['Redirection securisee...', 'Secure redirection...'],
  ['Confirmation en cours...', 'Confirming...'],
  ['Payer maintenant', 'Pay now'],
  ['Commande creee avec succes', 'Order created successfully'],
  ['Impossible de charger le panier', 'Unable to load cart'],
  ['Impossible de modifier la quantite', 'Unable to update quantity'],
  ['Produit retire du panier', 'Product removed from cart'],
  ['Erreur lors de la suppression', 'Error during removal'],
  ['Veuillez completer les informations de carte bancaire', 'Please complete the bank card information'],
  ['Lien de paiement introuvable.', 'Payment link not found.'],
  ['Impossible de lancer le paiement', 'Unable to start payment'],
  ['Redirection securisee', 'Secure redirection'],
  ['Confirmation en cours', 'Confirming'],
  ['SOLARLIGHT CLIENT', 'SOLARLIGHT CUSTOMER'],
  ['CVC', 'CVC'],

  ['Contactez-nous', 'Contact us'],
  ['Parlons de votre projet d eclairage solaire', 'Let us talk about your solar lighting project'],
  ['Parlons de votre projet d', 'Let us talk about your'],
  ['eclairage solaire', 'solar lighting project'],
  ['Contactez-nous pour une question ou consultez les avis produits partages par nos clients.', 'Contact us for a question or browse product reviews shared by our customers.'],
  ['Nom complet', 'Full name'],
  ['Votre nom', 'Your name'],
  ['Votre email', 'Your email'],
  ['Sujet', 'Subject'],
  ['Votre message...', 'Your message...'],
  ['Envoyer le message', 'Send message'],
  ['Message envoye', 'Message sent'],
  ['Impossible d envoyer le message', 'Unable to send message'],
  ['Avis produits', 'Product reviews'],
  ['Ce que nos clients pensent des produits', 'What our customers think about the products'],
  ['Aucun avis produit pour le moment. Le prochain avis envoye apparaitra ici.', 'No product reviews yet. The next submitted review will appear here.'],
  ['Laisser un avis', 'Leave a review'],
  ['Veuillez vous connecter pour laisser un avis produit', 'Please log in to leave a product review'],
  ['Choisissez un produit achete', 'Choose a purchased product'],
  ['Impossible d envoyer l avis', 'Unable to send the review'],
  ['Chargement de vos produits...', 'Loading your products...'],
  ['Choisir un produit', 'Choose a product'],
  ['Connectez-vous pour choisir un produit', 'Log in to choose a product'],
  ['avis deja envoye', 'review already sent'],
  ['Publier mon avis', 'Publish my review'],
  ['Votre avis sur le produit', 'Your product review'],
  ['Partagez votre avis sur le produit...', 'Share your opinion about the product...'],
  ['Connectez-vous pour publier un avis sur un produit achete.', 'Log in to publish a review for a purchased product.'],
  ['Aucun produit achete disponible pour laisser un avis.', 'No purchased product is available for a review.'],
  ['Vous avez deja laisse un avis pour tous vos produits achetes.', 'You have already reviewed all your purchased products.'],
  ['Impossible de charger les avis pour le moment.', 'Unable to load reviews right now.'],

  ['Gestion des utilisateurs', 'User management'],
  ['management', 'gestion'],
  ['Ajoutez, modifiez ou supprimez des utilisateurs et attribuez le role administrateur si necessaire.', 'Add, edit, or delete users and assign the administrator role if necessary.'],
  ['Entrez le nom complet', 'Enter full name'],
  ['Entrez l adresse email', 'Enter email address'],
  ['Laisser vide pour conserver', 'Leave blank to keep current'],
  ['Entrez le mot de passe', 'Enter password'],
  ['Rupture', 'Out of stock'],
  ['Entrez le nom du produit', 'Enter product name'],
  ['Entrez la description du produit', 'Enter product description'],
  ['Entrez le prix', 'Enter price'],
  ['Entrez le stock disponible', 'Enter available stock'],
  ['Choisir un fichier', 'Choose a file'],
  ['Aucun fichier choisi', 'No file chosen'],
  ['Aucun nouveau fichier choisi', 'No new file chosen'],
  ['Apercu de l image', 'Image preview'],
  ['Laisser vide pour conserver l image actuelle.', 'Leave blank to keep the current image.'],
  ['L image choisie sera utilisee pour le produit.', 'The selected image will be used for the product.'],
  ['Toutes les categories', 'All categories'],
  ['Produit', 'Product'],
  ['Gateway', 'Gateway'],
  ['Carte', 'Card'],
  ['Last4', 'Last4'],
  ['Statut commande', 'Order status'],
  ['Statut paiement', 'Payment status'],
  ['Client', 'Client'],
  ['Chargement...', 'Loading...'],
  ['Actualiser', 'Refresh'],
  ['Voir collection', 'View collection'],
  ['Des univers solaires pour chaque usage', 'Solar lighting for every use'],
  ['Explorez des selections plus claires par type d eclairage pour le jardin, la facade, les allees, les terrasses et les mises en ambiance.', 'Explore clearer selections by lighting type for the garden, facade, paths, terraces, and atmospheres.'],
  ['Super Admin', 'Super Admin'],
  ['User', 'User'],
  ['Admin', 'Admin'],
  ['En_attente', 'Pending'],
  ['en_attente', 'Pending'],
  ['pending', 'En attente'],
  ['payee', 'Paid'],
  ['payé', 'Paid'],
  ['annulee', 'Cancelled'],
  ['refusee', 'Rejected'],
  ['livree', 'Delivered'],
  ['confirmee', 'Confirmed'],
  ['Payee', 'Paid'],
  ['Paye', 'Paid'],
  ['livraison', 'delivery'],
  ['demo', 'demo']
]

const dynamicRules = {
  en: [
    [/^(.+?) est un (.+?) soigneusement selectionne pour apporter une lumiere elegante, une finition premium et un style moderne a vos espaces\.?(?: Modele (\d+) de notre collection avec installation simple et rendu lumineux confortable au quotidien\.?| .*)?$/i, (_, name, category, model) => `${translateCopy(name, 'en')} is a carefully selected ${resolveProductCategoryName(category, 'en')} designed to bring elegant lighting, a premium finish, and modern style to your spaces.${model ? ` Model ${model} from our collection with simple installation and comfortable everyday illumination.` : ''}`],
    [/^Equipe d un panneau solaire haute performance et d une batterie lithium longue duree, il offre un eclairage puissant et fiable toute la nuit, sans consommation d electricite\.$/i, () => 'Equipped with a high-performance solar panel and a long-life lithium battery, it provides powerful, reliable lighting all night without electricity consumption.'],
    [/^(\d+) produit(s?) charge(s?)(?: avec (\d+) filtre(s?))?$/i, (_, count, plural, loadedPlural, filters, filtersPlural) => `${count} product${plural ? 's' : ''} loaded${filters ? ` with ${filters} filter${filtersPlural ? 's' : ''}` : ''}`],
    [/^(\d+) article\(s\) dans votre panier$/i, (_, count) => `${count} item${Number(count) > 1 ? 's' : ''} in your cart`],
    [/^Affichage (\d+)-(\d+) sur (\d+) resultats$/i, (_, from, to, total) => `Showing ${from}-${to} of ${total} results`],
    [/^Collection (.+) : tous les produits correspondants sont filtres automatiquement\.$/i, (_, name) => `Collection ${name}: all matching products are filtered automatically.`],
    [/^(\d+) produits?$/i, (_, count) => `${count} product${Number(count) > 1 ? 's' : ''}`],
    [/^(\d+) avis$/i, (_, count) => `${count} review${Number(count) > 1 ? 's' : ''}`],
    [/^(\d+) etoiles? sur 5$/i, (_, rating) => `${rating} stars out of 5`],
    [/^Diminuer la quantite de (.+)$/i, (_, name) => `Decrease quantity of ${name}`],
    [/^Augmenter la quantite de (.+)$/i, (_, name) => `Increase quantity of ${name}`],
    [/^Commande #(.+)$/i, (_, id) => `Order #${id}`]
  ],
  fr: [
    [/^(.+?) is a carefully selected (.+?) designed to bring elegant lighting, a premium finish, and modern style to your spaces\.?(?: Model (\d+) from our collection with simple installation and comfortable everyday illumination\.?| .*)?$/i, (_, name, category, model) => `${translateCopy(name, 'fr')} est un ${resolveProductCategoryName(category, 'fr')} soigneusement selectionne pour apporter une lumiere elegante, une finition premium et un style moderne a vos espaces.${model ? ` Modele ${model} de notre collection avec installation simple et rendu lumineux confortable au quotidien.` : ''}`],
    [/^Equipped with a high-performance solar panel and a long-life lithium battery, it provides powerful, reliable lighting all night without electricity consumption\.$/i, () => 'Equipe d un panneau solaire haute performance et d une batterie lithium longue duree, il offre un eclairage puissant et fiable toute la nuit, sans consommation d electricite.'],
    [/^(\d+) product(s?) loaded(?: with (\d+) filter(s?))?$/i, (_, count, plural, filters, filtersPlural) => `${count} produit${plural ? 's' : ''} charge${plural ? 's' : ''}${filters ? ` avec ${filters} filtre${filtersPlural ? 's' : ''}` : ''}`],
    [/^(\d+) item(s?) in your cart$/i, (_, count) => `${count} article(s) dans votre panier`],
    [/^Showing (\d+)-(\d+) of (\d+) results$/i, (_, from, to, total) => `Affichage ${from}-${to} sur ${total} resultats`],
    [/^Collection (.+): all matching products are filtered automatically\.$/i, (_, name) => `Collection ${name} : tous les produits correspondants sont filtres automatiquement.`],
    [/^(\d+) product(s?)$/i, (_, count, plural) => `${count} produit${plural ? 's' : ''}`],
    [/^(\d+) review(s?)$/i, (_, count, plural) => `${count} avis`],
    [/^(\d+) stars out of 5$/i, (_, rating) => `${rating} etoiles sur 5`],
    [/^Decrease quantity of (.+)$/i, (_, name) => `Diminuer la quantite de ${name}`],
    [/^Increase quantity of (.+)$/i, (_, name) => `Augmenter la quantite de ${name}`],
    [/^Order #(.+)$/i, (_, id) => `Commande #${id}`]
  ]
}

const escapeRegExp = (value) => value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
const WORD_CHARACTER_PATTERN = 'A-Za-z0-9'

const replacePhrase = (value, from, to) => (
  value.replace(
    new RegExp(`(^|[^${WORD_CHARACTER_PATTERN}])(${escapeRegExp(from)})(?=$|[^${WORD_CHARACTER_PATTERN}])`, 'g'),
    (_, prefix) => `${prefix}${to}`
  )
)

const phraseMaps = phrasePairs.reduce(
  (maps, [fr, en]) => {
    maps.frToEn.set(fr, en)
    maps.enToFr.set(en, fr)
    return maps
  },
  { frToEn: new Map(), enToFr: new Map() }
)

Object.keys(baseTranslations.fr).forEach((key) => {
  phraseMaps.frToEn.set(baseTranslations.fr[key], baseTranslations.en[key])
  phraseMaps.enToFr.set(baseTranslations.en[key], baseTranslations.fr[key])
})

const sortedPhrasePairs = {
  en: [...phraseMaps.frToEn.entries()].sort((a, b) => b[0].length - a[0].length),
  fr: [...phraseMaps.enToFr.entries()].sort((a, b) => b[0].length - a[0].length)
}

export const translations = baseTranslations

export const translateCopy = (value, targetLanguage) => {
  if (typeof value !== 'string' || !value.trim()) {
    return value
  }

  const leading = value.match(/^\s*/)?.[0] || ''
  const trailing = value.match(/\s*$/)?.[0] || ''
  const compactValue = value.trim().replace(/\s+/g, ' ')
  const exactMap = targetLanguage === 'en' ? phraseMaps.frToEn : phraseMaps.enToFr

  if (exactMap.has(compactValue)) {
    return `${leading}${exactMap.get(compactValue)}${trailing}`
  }

  for (const [rule, replacer] of dynamicRules[targetLanguage] || []) {
    if (rule.test(compactValue)) {
      return `${leading}${compactValue.replace(rule, replacer)}${trailing}`
    }
  }

  let translated = compactValue

  sortedPhrasePairs[targetLanguage].forEach(([from, to]) => {
    translated = replacePhrase(translated, from, to)
  })

  return `${leading}${translated}${trailing}`
}
